import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

export interface CheckBoxOption {
    label: string | number,
    value: string | number,
}

interface InputCheckBoxGroup {
    name: string
    label: string
    register: UseFormRegisterReturn
    className?: string
    options: Array<CheckBoxOption>
    formErrorMessage?: string
}

export const InputCheckBoxGroup: React.FunctionComponent<InputCheckBoxGroup> = ({
    name,
    label,
    options,
    register,
    formErrorMessage
}) => {

    return (
        <div className='mb-8'>
            <label className='text-lg text-secondary-100 font-body font-bold mb-5'>{label}</label>
            <fieldset className='flex flex-col flex-wrap h-56'>
                {options.map((e, index) => (
                    <label key={index.toString()} className="checkbox" htmlFor={`${name}${index}`}>
                        <input
                            type="checkbox"
                            id={`${name}${index}`}
                            value={e.value}
                            {...register}
                        />
                        {e.label}
                        <span>
                            <FontAwesomeIcon icon={faCheck} style={{ color: "#FFFFFF", position: 'absolute', zIndex: 40 }} size={'1x'} />
                        </span>
                    </label>
                ))}
            </fieldset>
            {formErrorMessage && <p className='text-md text-alertdanger font-normal font-body'>{formErrorMessage}</p>}
        </div>
    );
};
